import { UserRole } from '../models/hospitality';

const ROLE_ALIASES: Record<string, UserRole> = {
  'platform-admin': 'platform-admin',
  platform_admin: 'platform-admin',
  platformadmin: 'platform-admin',
  PLATFORM_ADMIN: 'platform-admin',
  'tenant-admin': 'tenant-admin',
  tenant_admin: 'tenant-admin',
  tenantadmin: 'tenant-admin',
  TENANT_ADMIN: 'tenant-admin',
  reception: 'reception',
  RECEPTION: 'reception',
  operations: 'operations',
  OPERATIONS: 'operations',
  'tv-integration': 'tv-integration',
  tv_integration: 'tv-integration',
  tvintegration: 'tv-integration',
  TV_INTEGRATION: 'tv-integration'
};

const ROLE_PRIORITY: Record<UserRole, number> = {
  'platform-admin': 5,
  'tenant-admin': 4,
  operations: 3,
  reception: 2,
  'tv-integration': 1
};

export function normalizeUserRole(role: string | null | undefined): UserRole | null {
  if (!role) {
    return null;
  }

  return ROLE_ALIASES[role] ?? ROLE_ALIASES[role.toLowerCase().replace(/\s+/g, '-')] ?? null;
}

export function extractPrimaryUserRole(roles: readonly string[] | null | undefined): UserRole | null {
  let primaryRole: UserRole | null = null;

  for (const role of roles ?? []) {
    const normalized = normalizeUserRole(role);

    if (!normalized) {
      continue;
    }

    if (!primaryRole || ROLE_PRIORITY[normalized] > ROLE_PRIORITY[primaryRole]) {
      primaryRole = normalized;
    }
  }

  if (primaryRole) {
    return primaryRole;
  }

  return null;
}
